module.exports = __webpack_public_path__ + "static/media/replay.232aa50a.svg";